export default {
    catalogues: {
        name: '',
        fields: {
          title_th: 'ชื่อ (ไทย)',
          title_en: 'ชื่อ (อังกฤษ)',
          description_th: 'คำอธิบาย (ไทย)',
          description_en: 'คำอธิบาย (อังกฤษ)',
          period_th: 'ระยะเวลา (ไทย)',
          period_en: 'ระยะเวลา (อังกฤษ)',
          file: 'ชื่อไฟล์',
          title: 'ชื่อ (ไทย/อังกฤษ)',
          description: 'คำอธิบาย (ไทย/อังกฤษ)',
          period: 'ระยะเวลา (ไทย/อังกฤษ)',
          edit: {
            title: 'แก้ไข Catalogue',
            file: 'File',
            attachment_helper: 'อณุญาติเฉพาะไฟล์ PDF',
          },
          create: {title: 'สร้าง Catalogue'},
        }
    }
}